module.exports = __webpack_public_path__ + "img/entry-image-en.ce8628e7.png";